import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery } = mediaQueryStyles;
const {
  BreakpointNames: { md, xs },
} = constants.breakpoints;
const { colors } = constants;

export const sectionCss = {
  padding: "16px",
  borderBottom: `1px solid ${colors.ui.neutral[100]}`,

  "&:last-of-type": {
    borderBottom: "none",
  },

  [mediaQuery.downTo(xs)]: {
    padding: "24px 40px",
  },

  [mediaQuery.downTo(md)]: {
    padding: "16px 24px 16px 24px",
  },
};

export const quizOmissionContainerCss = {
  padding: "16px 16px 0",

  [mediaQuery.downTo(xs)]: {
    padding: "24px 40px 0",
  },

  [mediaQuery.downTo(md)]: {
    padding: "24px 24px 0",
  },
};

const white = colors.ui.white[700];

export const mobileSaveButtonCss = {
  position: "sticky",
  bottom: 0,
  borderTop: `1px solid ${colors.ui.neutral[100]}`,
  background: white,
};
